import React from "react";

import "./TreesUpper.scss";

import  tree from "../../assets/trees/tree.png"
import  treeB from "../../assets/trees/treeB.png"
import  treeD from "../../assets/trees/treeD.png"


function TreesUpper() {
  return (
    <div className="drzewka"> 
    <img className="t00 x-small" src={tree} alt=""/>
    <img className="t1 big" src={tree} alt=""/>
    <img className="t2 big" src={treeB} alt=""/>
    <img className="t3 medium" src={tree} alt=""/>
    <img className="t4 big" src={treeD} alt=""/>
    <img className="t5 small" src={tree} alt=""/>
    <img className="t6 big" src={tree} alt=""/>
    <img className="t7 medium" src={treeB} alt=""/>
    <img className="t8 big" src={tree} alt=""/>
    <img className="t9 big" src={treeD} alt=""/>
    <img className="t10 small" src={treeD} alt=""/>
    <img className="t11 medium" src={treeD} alt=""/>
    <img className="t12 medium" src={treeD} alt=""/>
    <img className="t13 medium" src={treeD} alt=""/>
    <img className="t14 xs-medium" src={treeB} alt=""/>
    <img className="t15 xs-medium" src={tree} alt=""/>
    <img className="t16 big" src={treeB} alt=""/>
    <img className="t17  medium" src={tree} alt=""/>
    <img className="t18 small" src={tree} alt=""/>
    <img className="t19 big" src={tree} alt=""/>
    <img className="t20 s-medium" src={tree} alt=""/>
    <img className="t21 big" src={tree} alt=""/>
    <img className="t22 big" src={treeB} alt=""/>
    <img className="t23 big" src={tree} alt=""/>
    <img className="t24 medium" src={treeD} alt=""/>
    <img className="t25 big" src={treeB} alt=""/>
    <img className="t26 s-medium" src={tree} alt=""/>
    <img className="t27 big" src={treeB} alt=""/>
    <img className="t28 big" src={treeB} alt=""/>
    <img className="t29 medium" src={tree} alt=""/>
    <img className="t30 s-medium" src={treeD} alt=""/>
    <img className="t31 medium" src={tree} alt=""/>
    <img className="t32 small" src={tree} alt=""/>
    <img className="t33 big" src={treeB} alt=""/>
    <img className="t34 xs-medium" src={tree} alt=""/>
    <img className="t35 medium" src={treeD} alt=""/>
    <img className="t36 medium" src={tree} alt=""/>
    <img className="t37 big" src={treeB} alt=""/>
    <img className="t38 medium" src={treeD} alt=""/>
    <img className="t39 xs-medium" src={tree} alt=""/>
    <img className="t40 medium" src={treeD} alt=""/>
    <img className="t41 big" src={tree} alt=""/>
    <img className="t42 big" src={treeB} alt=""/>
    <img className="t43 medium" src={tree} alt=""/>
    <img className="t44 big" src={tree} alt=""/>
    <img className="t45 medium" src={treeD} alt=""/>
    <img className="t46 big" src={tree} alt=""/>
    <img className="t47 big" src={treeB} alt=""/>
    <img className="t48 medium" src={tree} alt=""/>
    <img className="t49 big" src={tree} alt=""/>
    <img className="t50 medium" src={treeD} alt=""/>

    <img className="t51 big" src={tree} alt=""/>
    <img className="t52 big" src={treeB} alt=""/>
    <img className="t53 medium" src={tree} alt=""/>
    <img className="t54 big" src={tree} alt=""/>
    <img className="t55 medium" src={treeD} alt=""/>

    <img className="t56 x-small" src={tree} alt=""/>
    <img className="t57 medium" src={tree} alt=""/>
    <img className="t58 s-medium" src={tree} alt=""/>
    <img className="t59 small" src={tree} alt=""/>
    <img className="t60 small" src={treeD} alt=""/> 

    <img className="t61 x-small" src={tree} alt=""/>
    <img className="t62 small" src={treeB} alt=""/>
    <img className="t63 x-small" src={tree} alt=""/>
    <img className="t64 x-small" src={tree} alt=""/>
    <img className="t65 small" src={treeD} alt=""/>
    <img className="t66 medium" src={tree} alt=""/>
    <img className="t67 xs-medium" src={treeB} alt=""/>
    <img className="t68 big" src={tree} alt=""/>
    <img className="t69 small" src={tree} alt=""/>
    <img className="t70 medium" src={treeD} alt=""/>
    <img className="t71 medium" src={treeD} alt=""/>
    <img className="t72 big" src={tree} alt=""/>
    <img className="t73 big" src={treeB} alt=""/>
    <img className="t74 medium" src={tree} alt=""/>
    <img className="t75 big" src={tree} alt=""/>
    <img className="t76 medium" src={treeD} alt=""/>
    <img className="t77 big" src={tree} alt=""/>
    <img className="t78 big" src={treeB} alt=""/>
    <img className="t79 medium" src={tree} alt=""/>
    <img className="t80 big" src={tree} alt=""/>
    <img className="t81 small" src={treeD} alt=""/>
    <img className="t82 big" src={tree} alt=""/>
    <img className="t83 big" src={treeB} alt=""/>
    <img className="t84 medium" src={tree} alt=""/>
    <img className="t85 big" src={tree} alt=""/>
    <img className="t86 x-small" src={tree} alt=""/>
    <img className="t87 medium" src={tree} alt=""/>
    <img className="t88 s-medium" src={tree} alt=""/>
    <img className="t89 medium" src={tree} alt=""/>
    <img className="t90 small" src={treeD} alt=""/> 
    <img className="t91 big" src={tree} alt=""/>
    <img className="t92 big" src={treeB} alt=""/>
    <img className="t93 medium" src={tree} alt=""/>
    <img className="t94 big" src={tree} alt=""/>
    <img className="t95 medium" src={treeD} alt=""/>
    <img className="t96 big" src={tree} alt=""/>
    <img className="t97 big" src={treeB} alt=""/>
    <img className="t98 medium" src={tree} alt=""/>
    <img className="t99 big" src={tree} alt=""/>
    <img className="t100 medium" src={treeD} alt=""/>
    <img className="t101 big" src={tree} alt=""/>
    <img className="t102 medium" src={treeB} alt=""/>
    <img className="t103 s-medium" src={tree} alt=""/>
    <img className="t104 big" src={tree} alt=""/>
    <img className="t105 medium" src={treeD} alt=""/>
    <img className="t106 big" src={tree} alt=""/>
    <img className="t107 medium" src={treeB} alt=""/>
    <img className="t108 s-medium" src={tree} alt=""/>
    <img className="t109 big" src={tree} alt=""/>
    <img className="t110 medium" src={treeD} alt=""/>
    <img className="t111 big" src={tree} alt=""/>
    <img className="t112 medium" src={treeB} alt=""/>
    <img className="t113 s-medium" src={tree} alt=""/>
    <img className="t114 big" src={tree} alt=""/>
    <img className="t115 medium" src={treeD} alt=""/>

    <img className="t116 big" src={tree} alt=""/>
    <img className="t117 medium" src={treeB} alt=""/>
    <img className="t118 s-medium" src={tree} alt=""/>
    <img className="t119 big" src={tree} alt=""/>
    <img className="t120 medium" src={treeD} alt=""/>

    <img className="t121 big" src={tree} alt=""/>
    <img className="t122 medium" src={treeB} alt=""/>
    <img className="t123 s-medium" src={tree} alt=""/>
    <img className="t124 big" src={tree} alt=""/>
    <img className="t125 medium" src={treeD} alt=""/>

    </div>
  );
}

export default TreesUpper;